/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDevicesSetCoordsMutationRequest, StreamerBoxStreamerBoxDevicesSetCoordsMutationResponse, StreamerBoxStreamerBoxDevicesSetCoordsPathParams } from "../models/StreamerBoxStreamerBoxDevicesSetCoords";

export function getStreamerBoxStreamerBoxDevicesSetCoordsUrl(uuidOrId: StreamerBoxStreamerBoxDevicesSetCoordsPathParams["uuidOrId"]) {
  const res = { method: 'POST', url: `/streamer-box/devices/${uuidOrId}/set-coords` as const }
  return res
}

/**
 * @description Sets custom latitude and longitude for the device.
 * @summary Set device coordinates
 * {@link /streamer-box/devices/:uuidOrId/set-coords}
 */
export async function streamerBoxStreamerBoxDevicesSetCoords(uuidOrId: StreamerBoxStreamerBoxDevicesSetCoordsPathParams["uuidOrId"], data: StreamerBoxStreamerBoxDevicesSetCoordsMutationRequest, config: Partial<RequestConfig<StreamerBoxStreamerBoxDevicesSetCoordsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StreamerBoxStreamerBoxDevicesSetCoordsMutationResponse, ResponseErrorConfig<Error>, StreamerBoxStreamerBoxDevicesSetCoordsMutationRequest>({ method : "POST", url : getStreamerBoxStreamerBoxDevicesSetCoordsUrl(uuidOrId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}